module.exports = "/fonts/logo-sobatpajak-17d20ff46c9d99fc81b5e7c02fd6eb75.svg";